/**
 * SocialsDropdown — Cycling social icon button with dropdown menu
 * Ported from old ABET dashboard, adapted to use Lucide React icons
 */

import { useState, useEffect, useRef } from 'react'
import { MessageCircle, Twitter, Instagram, Youtube, Send, Mail, Coffee } from 'lucide-react'
import './SocialsDropdown.css'

const SOCIALS = [
  { name: 'Discord', Icon: MessageCircle, color: '#5865F2', url: 'https://discord.gg/9cez8Y7z' },
  { name: 'Twitter / X', Icon: Twitter, color: '#1DA1F2', url: 'https://x.com/ABEThq' },
  { name: 'Buy Me a Coffee', Icon: Coffee, color: '#FFDD00', url: 'https://buymeacoffee.com/abet' },
  { name: 'Instagram', Icon: Instagram, color: '#E4405F', url: null },
  { name: 'YouTube', Icon: Youtube, color: '#FF0000', url: null },
  { name: 'Telegram', Icon: Send, color: '#0088cc', url: null },
  { name: 'Email', Icon: Mail, color: '#3B7DD8', url: null },
]

export default function SocialsDropdown() {
  const [isOpen, setIsOpen] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(0)
  const dropdownRef = useRef(null)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % SOCIALS.length)
    }, 3000)
    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const current = SOCIALS[currentIndex]
  const CurrentIcon = current.Icon

  return (
    <div className="sd-dropdown" ref={dropdownRef}>
      <button
        className="sd-toggle"
        onClick={() => setIsOpen(!isOpen)}
        style={{ color: current.color }}
        title="Social Links"
      >
        <CurrentIcon size={18} />
      </button>

      {isOpen && (
        <div className="sd-menu">
          {SOCIALS.map(social => {
            const SIcon = social.Icon
            return social.url ? (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="sd-item"
              >
                <SIcon size={18} style={{ color: social.color }} />
                <span>{social.name}</span>
              </a>
            ) : (
              <div key={social.name} className="sd-item sd-disabled">
                <SIcon size={18} style={{ color: social.color }} />
                <span>{social.name}</span>
                <span className="sd-soon">Soon</span>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
